import { createFeatureSelector, createSelector } from '@ngrx/store';
import { OfferOverviewModel } from 'src/app/dashboard/components/overview/models/overview.model';

import { RequestsOverviewModel } from 'src/app/dashboard/components/overview/models/overview.model';

import { MyAdvertisementsState } from '../../models/my-advertisements.model';

export const selectActiveOffer =
  createFeatureSelector<MyAdvertisementsState>('myAdvertisementsModule');
export const selectActiveRequest =
  createFeatureSelector<MyAdvertisementsState>('myAdvertisementsModule');

export const getTotalNumberOfActiveOffers = createSelector(
  selectActiveOffer,
  (state: MyAdvertisementsState) => state.totalNumberOfActiveOffers,
);

export const getTotalNumberOfActiveRequests = createSelector(
  selectActiveRequest,
  (state: MyAdvertisementsState) => state.totalNumberOfActiveRequests,
);

export const selectActiveRequests = createSelector(
  selectActiveRequest,
  (state: MyAdvertisementsState) =>
    state.activeRequestsOverviewList?.map<RequestsOverviewModel>((overviewModel) => ({
      ...overviewModel,
      maxNitrogen: overviewModel.nKgPerTon
        ? overviewModel.nKgPerTon * overviewModel.amountInTons
        : undefined,
      maxPhosphate: overviewModel.pKgPerTon
        ? overviewModel.pKgPerTon * overviewModel.amountInTons
        : undefined,
      totalPrice: overviewModel.amountInTons * overviewModel.pricePerTon,
    })) ?? [],
);

export const selectClosedRequests = createSelector(
  selectActiveRequest,
  (state: MyAdvertisementsState) =>
    state.closedRequestsOverviewList?.map<RequestsOverviewModel>((overviewModel) => ({
      ...overviewModel,
      maxNitrogen: overviewModel.nKgPerTon
        ? overviewModel.nKgPerTon * overviewModel.amountInTons
        : undefined,
      maxPhosphate: overviewModel.pKgPerTon
        ? overviewModel.pKgPerTon * overviewModel.amountInTons
        : undefined,
      totalPrice: overviewModel.amountInTons * overviewModel.pricePerTon,
    })) ?? [],
);

export const selectCurrentTab = createSelector(
  selectActiveOffer,
  (state: MyAdvertisementsState) => state.currentTab,
);

export const selectActiveOfferList = createSelector(
  selectActiveOffer,
  (state: MyAdvertisementsState) =>
    state.activeOffersOverviewList?.map<OfferOverviewModel>((overviewModel) => ({
      ...overviewModel,
      maxNitrogen: overviewModel.nKgPerTon
        ? overviewModel.nKgPerTon * overviewModel.amountInTons
        : undefined,
      maxPhosphate: overviewModel.pKgPerTon
        ? overviewModel.pKgPerTon * overviewModel.amountInTons
        : undefined,
      totalPrice: overviewModel.amountInTons * overviewModel.pricePerTon,
    })) ?? [],
);

export const selectClosedDealsOfferList = createSelector(
  selectActiveOffer,
  (state: MyAdvertisementsState) =>
    state.closedDealsOffersList?.map<OfferOverviewModel>((overviewModel) => ({
      ...overviewModel,
      maxNitrogen: overviewModel.nKgPerTon
        ? overviewModel.nKgPerTon * overviewModel.amountInTons
        : undefined,
      maxPhosphate: overviewModel.pKgPerTon
        ? overviewModel.pKgPerTon * overviewModel.amountInTons
        : undefined,
      totalPrice: overviewModel.amountInTons * overviewModel.pricePerTon,
    })) ?? [],
);
